<!--财务中心 供应商结算-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="供应商：">
            <el-select filterable v-model="searchForm.supplier_name" placeholder="请选择" :clearable="true">
              <el-option v-for="item in supplier" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月份：">
            <el-date-picker v-model="searchForm.MONTH" value-format="yyyy-MM" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doQueryTable()" :loading="loading">筛选</el-button>
            <el-button type="primary" plain @click="exportBalanceTable()" :loading="loading" v-if="fun_dic[115030101]">
              导出
            </el-button>
            <el-button type="primary" plain @click="导出供应商采购统计单模态框 = true" :loading="loading"  v-if="fun_dic[115030102]">
              导出供应商采购统计单
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商名称"></el-table-column>
          <el-table-column prop="MONTH" label="月份"></el-table-column>
          <el-table-column prop="REAL_ORDER_FEE" label="结算金额"></el-table-column>
          <el-table-column prop="PAPER_FEE" label="纸质金额"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" icon="el-icon-view" type="text" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-view" @click="invoiceDetail(scope.row)">开票明细</el-button>
              <el-button type="text" size="small" icon="el-icon-view" @click="GYS_Evaluate(scope.row)">供应商评价</el-button>
              <el-button type="text" size="small" icon="el-icon-edit" @click="UpdateSettlementAmount(scope.row)">
                更新结算金额
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>


    <el-dialog title="导出供应商采购统计单" center :visible.sync="导出供应商采购统计单模态框" width="600px"
               :close-on-click-modal="false">
      <el-form ref="导出供应商采购统计单表单" v-model="导出供应商采购统计单表单">
        <el-form-item label="日期范围：" label-width="150px">
          <el-date-picker v-model="导出供应商采购统计单表单.date" type="daterange" align="right" unlink-panels
                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                          style="width: 80%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="导出供应商采购统计单模态框 = false">取消</el-button>
        <el-button @click="确认导出供应商采购统计单()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addOrderFun, newSupplierName, exportSupplierBalanceFun } from 'api/tcBanlance';
import http from '@/assets/common/http';
import { getActionFun } from '@/assets/api/login';
import util from '@/assets/common/util';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      PAGE_ID: '1150301',
      fun_dic: { 115030101: 0 ,115030102: 0 },
      tableData: [],
      searchForm: {
      },
      supplier: [],
      currentPage: 1,
      pageSize: 15,
      loading: false,
      totalCount: 0,
      导出供应商采购统计单模态框: false,
      导出供应商采购统计单表单: {},
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.READY_SEARCH_DATA_CONDITION.CONDITION) {
      this.searchForm = this.READY_SEARCH_DATA_CONDITION.CONDITION;
      this.currentPage = this.READY_SEARCH_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.querySupplier();
    this.queryBeforeFun();
  },
  computed: {
    // 上一次的搜索结果和条件
    READY_SEARCH_DATA_CONDITION() {
      return this.$store.state.READY_SEARCH_DATA_CONDITION;
    },
  },
  methods: {
    确认导出供应商采购统计单() {
      if (this.导出供应商采购统计单表单.date && this.导出供应商采购统计单表单.date[0]) {
        const params = {
          SERVICE_ID: '10026',
          OTYPE: 100,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          START_DAY: this.导出供应商采购统计单表单.date[0],
          END_DAY: this.导出供应商采购统计单表单.date[1],
        };
        http.post(params).then((res) => {
          this.导出供应商采购统计单模态框 = false;
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
    },
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    invoiceDetail(row) {
      this.$router.push({ name: 'gysInvoiceDetail', params: { isgys: '1' } });
      sessionStorage.setItem('GYS_ID', row.GYS_ID);
      sessionStorage.setItem('SUPPLIER_ID', row.SUPPLIER_ID);
      sessionStorage.setItem('MONTH', row.MONTH);
    },
    GYS_Evaluate(row) {
      sessionStorage.setItem('GYS_ID_Evaluate', row.GYS_ID);
      sessionStorage.setItem('SUPPLIER_ID_Evaluate', row.SUPPLIER_ID);
      sessionStorage.setItem('MONTH_Evaluate', row.MONTH);
      this.$router.push({ path: '/GYS_Evaluate/detail' });
    },
    handleCurrentChange() {
      this.queryData();
    },
    // -------------------------------搜索
    doQueryTable() {
      this.currentPage = 1;
      this.queryData();
    },
    // -------------------------------查询供应商结算
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.supplier_name) {
        params.SUPPLIER_ID = this.searchForm.supplier_name;
      }
      if (this.searchForm.MONTH && this.searchForm.MONTH[0]) {
        params.START_MONTH = this.searchForm.MONTH[0];
        params.END_MONTH = this.searchForm.MONTH[1];
      }
      this.loading = true;
      addOrderFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].DATA;
          this.totalCount = result[0].TOTAL;
          this.$store.dispatch('SET_READY_SEARCH_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    detail(row) {
      this.$router.push({ path: '/supplierOrderList/detail' });
      sessionStorage.setItem('ID', row.SUPPLIER_ID);
      sessionStorage.setItem('GYS_ID', row.GYS_ID);
      sessionStorage.setItem('MONTH', row.MONTH);
    },
    // -----------------------------------获取供应商名称
    querySupplier() {
      const params = {};
      if (this.searchForm.supplier_name) {
        params.SUPPLIER_NAME = this.searchForm.supplier_name;
      }
      newSupplierName(params).then((res) => {
        if (res.length !== 0) {
          this.supplier = res[0].list;
        } else {
          this.supplier = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportBalanceTable() {
      const params = {};
      if (this.searchForm.supplier_name) {
        params.SUPPLIER_ID = this.searchForm.supplier_name;
      }
      if (this.searchForm.MONTH && this.searchForm.MONTH[0]) {
        params.START_MONTH = this.searchForm.MONTH[0];
        params.END_MONTH = this.searchForm.MONTH[1];
      }
      this.loading = true;
      exportSupplierBalanceFun(params).then((result) => {
        window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    UpdateSettlementAmount({
      GYS_ID, SUPPLIER_ID, GYS_BALANCE_ID, MONTH,
    }) {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 35,
        GYS_ID,
        SUPPLIER_ID,
        GYS_BALANCE_ID,
        MONTH,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '更新成功', type: 'success' });
        this.queryData();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/supplierBalance.vue